import { FirebaseError } from 'firebase/app';
import { isDevRuntime } from '../constants/devControls';

export function isFirestoreQuotaExceeded(err: unknown): boolean {
  if (err instanceof FirebaseError && err.code === 'resource-exhausted') return true;
  const message = err instanceof Error ? err.message : String(err);
  return /quota exceeded|resource-exhausted/i.test(message);
}

/** User-facing copy when Spark/Blaze daily Firestore caps are hit. */
export function firestoreQuotaExceededMessage(): string {
  return isDevRuntime()
    ? 'Firestore quota is exhausted for this Firebase project. For localhost testing, run the Firebase emulators and set VITE_FIRESTORE_EMULATOR_HOST=localhost:8080, or wait for the project quota to reset.'
    : 'Firestore quota is exhausted right now. Please try again later.';
}

/** Re-throw quota errors with a clearer message; pass other errors through. */
export function wrapFirestoreQuotaError(err: unknown): Error {
  if (isFirestoreQuotaExceeded(err)) {
    return new Error(firestoreQuotaExceededMessage());
  }
  if (err instanceof Error) return err;
  return new Error(String(err));
}
